import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=eca2ce2e&scoped=true&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"
import style0 from "./Terms.vue?vue&type=style&index=0&id=eca2ce2e&prod&lang=css&"
import style1 from "./Terms.vue?vue&type=style&index=1&id=eca2ce2e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca2ce2e",
  null
  
)

export default component.exports